export async function createLog(driverReturn, email, state){

  console.log("Start Log");
  console.log(driverReturn)
  console.log(email);
  const userUrl = '/api/user/byEmail/'+email;
  const logUrl = '/api/user/transaction';
  const method = "POST";

  console.log("LOG")

  console.log("Log URL: "+userUrl)

  const toIDOdate = () =>{
    const currentDate = new Date();
    return currentDate.toISOString();
  }

  const getUser = async(userUrl) => {
        const res = await fetch(userUrl, {
            method: "GET"
        }).catch((err) => {
            console.log("Log Error: " + err )
        })
        return res.json();
    }

    const postLog = async(logUrl, data) => {
        console.log(JSON.stringify(data))
        const res = await fetch(logUrl, {
            method: method, 
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).catch((err) => {
            console.log("Log Error: " + err )
        })
        return res.json();
    }

  //console.log("Log Entry: " + res);

  const data = await getUser(userUrl)


  
   while(data === "[object Promise]"){
        console.log("Loading");
    }

    console.log("USER Data: "+JSON.stringify(data));

  const log = {
    "transactionId": driverReturn?.TransactionGUID,
    "timestamp":  toIDOdate(),
    "category": data?.user?.userDetails?.category,
    "firstName": data?.user?.userDetails?.userName.firstName,
    "lastName":  data?.user?.userDetails?.userName.lastName,
    "orgCoordEmail": data?.user?.userDetails?.orgCoordEmail,
    "state":  data?.user?.userDetails?.state,
    "userEmail": email    
  }

  console.log("LOG ENTRY :"+JSON.stringify(log))

    const res = await postLog(logUrl, log)

   while(data === "[object Promise]"){
        console.log("Loading");
    }

    console.log("Log Object: "+ JSON.stringify(log));
    console.log("Loggng Response: "+JSON.stringify(res));
}
